



























import { Vue, Component, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import * as config from './config';
import { rank } from './api/index';
Vue.use(List);
@Component({
  components: {},
})
export default class Ranking extends Vue {
  option = config.OPTHINES;
  loading = false;
  finished = false;
  page = 1;
  rankList: any[] = [];
  rankTabs: any[] = ['区域排名', '学校排名'];
  loadingStatus = true;
  activeTabs: number = 0;
  async created() {
    // const res = await rank(1, this.page);
    // this.rankList = res.data;
  }
  public cleanData() {
    this.rankList = [];
    this.loading = false;
    this.finished = false;
    this.page = 1;
  }
  @Watch('activeTabs')
  public onTabsChange(newval: string) {
    this.cleanData();
  }
  public changeTabs(index: number) {
    this.activeTabs = index;
    this.onLoad();
    // setTimeout(() => {
    //   this.onLoad();
    // }, 100);
  }
  onLoad() {
    if (this.loadingStatus) {
      this.loadingStatus = false;
      setTimeout(() => {
        rank(this.activeTabs + 1, this.page).then((res) => this.endData(res));
      }, 150);
    }
  }
  endData(res: any) {
    if (!res.data) {
      this.finished = true;
    } else {
      this.rankList = [...this.rankList, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = true;
  }
}
